import { useState } from 'react';
import UpgradeModal from './UpgradeModal';

/**
 * Full-page locked card shown in place of a feature the user's tier
 * cannot access.  Used for route-level locks (Bet Tracker, Pattern
 * Finder tabs, etc.).
 *
 * @param {Object} props
 * @param {string} props.featureName
 * @param {string} props.description
 * @param {"pro"|"premium"} props.requiredTier
 * @param {React.ReactNode} [props.iconComponent]
 */
export default function LockedFeatureCard({
  featureName,
  description,
  requiredTier = 'pro',
  iconComponent,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const tierLabel = requiredTier === 'premium' ? 'Premium' : 'Pro';

  return (
    <>
      <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
        {iconComponent ? (
          <div className="mb-5 text-[#94a3b8]">{iconComponent}</div>
        ) : (
          <div className="mb-5">
            <svg className="w-12 h-12 text-[#94a3b8] dark:text-[#505a6e] mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
            </svg>
          </div>
        )}
        <h3 className="text-[18px] font-semibold text-[#111827] dark:text-[#e2e8f0] mb-2" style={{ fontFamily: 'var(--font-sans)' }}>
          {featureName}
        </h3>
        <p className="text-[14px] text-[#4b5563] dark:text-[#94a3b8] max-w-md mb-3 leading-relaxed" style={{ fontFamily: 'var(--font-sans)' }}>
          {description || `Unlock ${featureName} with a ${tierLabel} subscription.`}
        </p>
        <p className="text-[12px] font-medium text-[#6B7280] dark:text-[#8892a8] mb-5" style={{ fontFamily: 'var(--font-sans)' }}>
          Required: <span className="text-[#005BB3] dark:text-[#3b82f6]">{tierLabel}</span>
        </p>
        <button
          onClick={() => setModalOpen(true)}
          className="rounded-md bg-[#005BB3] px-5 py-2.5 text-[14px] font-medium text-white hover:bg-[#004a93] transition-colors duration-150"
          style={{ fontFamily: 'var(--font-sans)' }}
        >
          Upgrade to {tierLabel}
        </button>
      </div>

      <UpgradeModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        suggestedTier={requiredTier}
        triggerFeature={featureName}
      />
    </>
  );
}
